import { useState } from 'react';

export const useTooltip = () => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return {
    isVisible,
    showTooltip,
    hideTooltip,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Tooltip/hooks/useTooltip.js